import { GenericDataType } from "src/modules/enaio/netgen/GenericDataType";
import { SmErrorHandler } from "src/modules/sm-base/misc/sm-error-handler";
import { TableCellType } from "src/modules/sm-base/netgen/TableCellType";
import { Dates } from "src/modules/utils/shared/dates";
import { Objects } from "src/modules/utils/shared/objects";
import { Strings } from "src/modules/utils/shared/strings";
import { Utils } from "src/modules/utils/shared/utils";

export class EnaioFrontendColumn {
    //netgen start
    id: string;
    title: string;
    source: string;
    selectFields: string[];
    selectFieldsParent: string[];
    type: GenericDataType = GenericDataType.string;
    //netgen end

    constructor(id: string, title: string = null) {
        this.id = id;
        this.title = title;
    }

    getTitle(): string {
        return Strings.def(this.title, this.id);
    }

    toTableCellType(): TableCellType {
        switch (this.type) {
            case GenericDataType.string:
                return TableCellType.string;
            case GenericDataType.int:
                return TableCellType.int;
            case GenericDataType.decimal:
                return TableCellType.decimal;
            case GenericDataType.bool:
                return TableCellType.bool;
            case GenericDataType.date:
                return TableCellType.date;
            case GenericDataType.dateTime:
                return TableCellType.dateTime;
            default:
                throw new Error("Der GenericDataType " + this.type + " kann nicht zu TableCellType konvertiert werden");
        }
    }

    toTableValue(value: any): any {
        if (value == null || value == "") {
            return value;
        }

        try {
            switch (this.type) {
                case GenericDataType.string:
                    return Objects.toString(value);
                case GenericDataType.int:
                    return value == "" ? "" : Utils.toNumber(value);
                case GenericDataType.decimal:
                    return value == "" ? "" : Utils.toNumber(value);
                case GenericDataType.bool:
                    return Utils.toBool(value);
                case GenericDataType.date:
                    return Dates.to(value);
                case GenericDataType.dateTime:
                    return Dates.to(value);
                default:
                    throw new Error("Der GenericDataType " + this.type + " kann nicht zu TableCellType konvertiert werden");
            }
        }
        catch (error) {
            SmErrorHandler.instance.handleError(error);
            return "";
        }
    }
}
